import { useState } from "react";

import AddEmployee from "./AddEmployee";
import { Link } from "react-router-dom";
import Permission from "../RoleManagement/Permission";

const CreateEmployee = () => {

    const [selectedRow, setSelectedRow] = useState({});
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [operation, setOperation] = useState();

    const handleAddClick = () => {
        setSelectedRow({
            name: "",
            user_id: 0,
            email: "",
            contact: "",
            is_supervisor: 0,
            designation: "",
            supervisor_id: "",
            department_id: "",
            role_id: "",
            type: "NA"
        });
        setShowOffcanvas(!showOffcanvas);
        setOperation("create")
    };

    return (
        <>
            <Permission access={"/addemployee"}>
                <button onClick={() => handleAddClick()} className="btn-orange">Add Employee Master</button>
            </Permission>
            <AddEmployee
                selectedRow={selectedRow}
                setShowOffcanvas={setShowOffcanvas}
                showOffcanvas={showOffcanvas}
                setSelectedRow={setSelectedRow}
                operation={operation}
            />

        </>

    );

}

export default CreateEmployee;